
import ApiService from "@/core/services/api.service";


export const SET_LISTA_TAXA_EVENTOS = "setListSetores";
export const SET_LISTA_TAXA_EVENTOS_REV = "setListSetoresRev";
export const SET_TAXA_EVENTOS = "setSetores";
export const SET_ROTA = "setRota"
export const SET_MESSAGE_ALERT = 'setMensagem'




const actions = {
    //evento
    async create_taxa_eventos(context, value) {

        await ApiService.post('taxa_eventos', value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },




    async update_taxa_eventos(context, value) {

        await ApiService.put('taxa_eventos/'+value.id,value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async listar_taxa_eventos(context) {
        await ApiService.get('taxa_eventos')
            .then(response => {
                context.commit(SET_LISTA_TAXA_EVENTOS, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },

    async bloquear_taxa_eventos(context, value) {


        await ApiService.delete("taxa_eventos/" + value.id)
          .then((response) =>
            context.commit(SET_MESSAGE_ALERT, {
              tipo: "success",
              message: response.data,
            })
          )
          .catch((error) =>
            context.commit(SET_MESSAGE_ALERT, {
              tipo: "error",
              message: error.response.data,
            })
          );
    
    
   
        context.commit(SET_LISTA_TAXA_EVENTOS_REV, value)
    
    
      },

      set_rota(context, value) {
        context.commit(SET_ROTA,value)
      }



};
const getters = {};

const mutations = {
    [SET_LISTA_TAXA_EVENTOS](state, value) {
        state.lista_taxa_eventos = value;
    },
    [SET_LISTA_TAXA_EVENTOS_REV](state, value) {
        state.lista_taxa_eventos = state.lista_taxa_eventos.filter(
            (setor) => setor.id !== value.id
        );
    },
    [SET_TAXA_EVENTOS](state, value) {
        state.evento = value;
    },
    [SET_ROTA](state,value){
        state.rota = value
    },
    [SET_MESSAGE_ALERT](state, value) {
      
        let customMessage;
        if (typeof value.message === "object") {
    
          customMessage = value.message.msg;
        }
        state.mensagem_alert = {
          tipo: value.tipo,
          message: customMessage ? customMessage : value.msg,
        };
      },

};

const state = {
    lista_taxa_eventos: [],
    lista_taxa_eventos_Evento: [],
    evento:{},
    mensagem_alert: "",
    rota:"",

};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
